import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

export const StickyCTA = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const phoneNumber = "+905415878822";
  const message = t('whatsapp.message');
  const whatsappLink = `https://web.whatsapp.com/send?phone=${encodeURIComponent(phoneNumber)}&text=${encodeURIComponent(message)}`;

  useEffect(() => {
    const dismissed = window.localStorage.getItem('insStickyCtaDismissed');
    if (dismissed === 'true') {
      setIsDismissed(true);
    }

    const toggleVisibility = () => {
      // Show CTA when scrolled past the viewport height (approx. past the hero section)
      if (window.scrollY > window.innerHeight && !isDismissed) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => window.removeEventListener('scroll', toggleVisibility);
  }, [isDismissed]);

  const handleClose = () => {
    setIsVisible(false);
    setIsDismissed(true);
    window.localStorage.setItem('insStickyCtaDismissed', 'true');
  };

  return (
    <AnimatePresence>
      {isVisible && !isDismissed && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ ease: "easeInOut", duration: 0.4 }}
          className="fixed bottom-0 left-0 right-0 z-40"
        >
          <div className="container mx-auto px-4 pb-4">
            <div className="bg-brand-navy/90 backdrop-blur-sm p-4 rounded-lg shadow-2xl flex items-center justify-between gap-6">
              <div className="flex-1">
                <h3 className="font-bold text-white text-base md:text-lg">
                  {t('stickyCTA.title')}
                </h3>
                <p className="text-neutral-300 text-xs md:text-sm">
                  {t('stickyCTA.subtitle')}
                </p>
              </div>
              <div className="flex items-center gap-3">
                <button
                  type="button"
                  onClick={handleClose}
                  className="hidden rounded-full border border-white/30 px-3 py-1 text-xs font-medium text-white/80 transition hover:border-white hover:text-white md:inline-flex"
                >
                  {t('common.close', 'Kapat')}
                </button>
              <Button asChild className="bg-brand-turquoise hover:bg-teal-700 text-white flex-shrink-0">
                <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
                  {t('stickyCTA.buttonText')}
                  <ArrowRight className="w-4 h-4 ml-2 rtl:mr-2 rtl:ml-0" />
                </a>
              </Button>
              <button
                type="button"
                onClick={handleClose}
                className="inline-flex md:hidden h-8 w-8 items-center justify-center rounded-full border border-white/30 text-white/80 transition hover:border-white hover:text-white"
                aria-label={t('common.close', 'Kapat')}
              >
                ×
              </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
